import RenderFlights from "./Flights";
import Footer from "./Footer";
import { FaCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const slugify = (title) => title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
const blogs = [
  {
    title: "24/7 Customer Support – We're Here Anytime You Need Us",
    date: "27 Jun, 2025",
    content:
      "BookTrip4Me allows customers to enjoy a smooth booking experience without much hassle. But,in this fast-paced technology-driven world....",
    link: "#"
  },
  {
    title: "How Can I Speak To A Live Person At American Airlines?",
    date: "25 Jun, 2025",
    content:
      "American Airlines is a budget-friendly carrier that offers comfortable and secure flight bookings to popular destinations. To speak with a live person at America Airlines,....",
    link: "#"
  },
  {
    title: "How To Book Flights Instantly With BookTrip4Me",
    date: "22 Jun, 2025",
    content:
      "BookTrip4Me has an organised and user-friendly interface that allows an effortless and seamless booking experience for the customers. This allows customers...",
    link: "#"
  }
];

const Ticketpage = () => {
    //US ticketing page for the mobile and web app 
    return (
  <div className="w-full h-screen max-h-[100vh]">
    <img 
      src="/assets/gen1img.png" 
      className="w-full h-full object-fill hidden md:block" 
      alt="Banner"
    />
        <div className="mt-8 max-w-full">
       <RenderFlights />
       </div>
        <div className="text-center font-bold mt-8 text-3xl">Blogs</div>
       <div className="max-w-7xl mx-auto px-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mb-4 mt-6">
               {blogs.map((blog, index) => (
                 <div
                   key={index}
                   className="bg-white border-4 border-yellow-400 p-5 rounded-xl shadow-md hover:shadow-xl transition duration-300 flex flex-col justify-between"
                 >
                   <div>
                     <div className="flex items-center justify-between text-xs text-gray-400 mb-2">
                       <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded-full text-[11px]">Blog</span>
                       <span className="flex items-center gap-1">
                         <FaCalendarAlt className="text-orange-500" /> {blog.date}
                       </span>
                     </div>
                     <h2 className="text-md font-bold text-gray-800 mb-2 leading-snug">
                       {blog.title}
                     </h2>
                     <p className="text-sm text-gray-600 mb-4">
                       {blog.content}
                     </p>
                   </div>
                   <Link to={`/blog/${slugify(blog.title)}`} className="text-orange-500 font-semibold">
                   Read More →
                   </Link>
                 </div>
               ))}
             </div>
        <br /><br />
    <Footer/>
  </div>
);

    
}

export default Ticketpage;
